import AdminLayout from "./components/AdminLayout";
import UserList from "./pages/UserList";
import DeviceList from "./pages/DeviceList";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import NewsList from "./pages/NewsList";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Navigate to="/admin" replace />} />
                <Route path="/admin/login" element={<Login />} />
                <Route
                    path="/admin"
                    element={<ProtectedRoute><AdminLayout><Dashboard /></AdminLayout></ProtectedRoute>}
                />
                <Route
                    path="/admin/users"
                    element={<ProtectedRoute><AdminLayout><UserList /></AdminLayout></ProtectedRoute>}
                />
                <Route
                    path="/admin/devices"
                    element={<ProtectedRoute><AdminLayout><DeviceList /></AdminLayout></ProtectedRoute>}
                />
                <Route
                    path="/admin/news"
                    element={<ProtectedRoute><AdminLayout><NewsList /></AdminLayout></ProtectedRoute>}
                />
            </Routes>
        </Router>
    );
}

export default App;
